/**
 * Core / Plugin: Helpers
 * -----------------------------------------------------------------------------
 * Vue plugin to extend Vue instance with global helpers.
 * - Create separate files for each and add in alphabetical order.
 *
 */
import blockClass from '~/core/helpers/block-class'
import classHelper from '~/core/helpers/class'
import formatDate from '~/core/helpers/format-date'
import formatImageUrl from '~/core/helpers/format-image-url'
import formatMoney from '~/core/helpers/format-money'
import string from '~/core/helpers/string'
import timing from '~/core/helpers/timing'
import variable from '~/core/helpers/variable'

/**
 * Expose install method.
 * - See imported files for supported arguments and what's returned.
 */
export default {
  install: (app) => {
    app.config.globalProperties.$blockClass = blockClass
    app.config.globalProperties.$class = classHelper
    app.config.globalProperties.$formatDate = formatDate
    app.config.globalProperties.$formatImageUrl = formatImageUrl
    app.config.globalProperties.$formatMoney = formatMoney
    app.config.globalProperties.$string = string
    app.config.globalProperties.$timing = timing
    app.config.globalProperties.$variable = variable
  },
}

/**
   * Format url to include market handle url.
   * @param {String} url - Url string.
   * @returns {String}
   */
export function formatUrl(url) {
  const pathname = new URL(url).pathname
  const primary = cnvs.strings.defaultLocalization.primaryMarket
  const country = cnvs.store.country.toLowerCase()
  const language = cnvs.store.language.toLowerCase()
  const isPrimaryDomain = primary.domain.toLowerCase() === country
  const isPrimaryLocale = primary.locale.toLowerCase() === language
  let updatedPathname = `/${language}-${country}${pathname}`

  if (isPrimaryDomain) {
    updatedPathname = updatedPathname.replace(`-${country}`, '')

    if (isPrimaryLocale) {
      updatedPathname = updatedPathname.replace(`/${language}`, '')
    }
  }

  return updatedPathname
}
